

























import { OWebPageBase, OWebRouteContext } from "oweb";
import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";
import { SXSector } from "../../gobl.bundle";

@Component
export default class PSector extends BaseComponent {
	loading = false;

	get sectorId() {
		return app.store.routeContext.getToken("id");
	}
	get sector() {
		return app.services.sectors.identify(this.sectorId);
	}
	get mainComponent() {
		return app.store.route!.slug;
	}
	get customThemeData() {
		if (this.sector) {
			let data = this.ux_custom_data(this.sector.data);
			return {
				"--bg-color": data["bg_color"],
				"--txt-color": data["txt_color"]
			};
		}
		return {};
	}

	created() {
		if (!this.sector) {
			let x = this,
				always = () => (x.loading = false);
			x.loading = true;
			app.services.sectors.get(this.sectorId, "", always, always, false);
		}
	}
}
